import { Component } from '@angular/core';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../../globals';
import { getCurrencySymbol } from '@angular/common';
import { ProductsServices } from "../../../services";
import { StaticsServices } from '../../../../services/statics';
import { TranslateService } from '@ngx-translate/core';
import { ArticlesListPage } from '../../../../articles/articles-list/articles-list';
import { ArticleViewPage } from '../../../../articles/articles-view/article-view';
import { AnalyticsServices } from '../../../../services/analyticsServices';
import { AIServices } from '../../../../services/aiServices';
import { AddonsTriggerVersionProPage } from '../../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ProductCreateWfoodcostPricePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-product-create-wfoodcost-price',
  templateUrl: 'product-create-wfoodcost-price.html',
})
export class ProductCreateWfoodcostPricePage {

  pvp: number = 0;
  pvp2: number = 0;
  pvp3: number = 0;
  pvp_supplement: number = 0;
  pvp_combo_extra: number = 0;
  pvp_takeaway: number = 0;
  update_state: boolean = false;
  product_uid: string;
  product_name: string;
  _currency: any;
  product_measurement: string;
  product: any;
  product_tax: number = this.globals.RESTAURANT_TAX;
  show_alert: boolean = true;
  ean: string = "";
  loaderAI: boolean = false;
  suggestedPrice: number = 0;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public productsServices: ProductsServices,
    public staticsServices: StaticsServices,
    public translate: TranslateService,
    private alertCtrl: AlertController,
    private analyticsServices: AnalyticsServices,
    public aiServices: AIServices) {

    this.product_uid = this.navParams.get('product_uid');
    this.update_state = this.navParams.get('update_state');
    this.product_name = this.navParams.get('product_name');
    this.product_measurement = this.navParams.get('product_measurement');
    this.product = this.navParams.get('product') || {};

    if (this.product && this.product.tax != undefined) {
      this.product_tax = this.product.tax;
    }

    if (this.update_state) {//If update is true
      this.pvp = this.navParams.get('pvp');
      this.pvp2 = this.navParams.get('pvp2');
      this.pvp3 = this.navParams.get('pvp3');
      this.pvp_supplement = this.navParams.get('pvp_supplement');
      this.pvp_combo_extra = this.navParams.get('pvp_combo_extra');
      this.pvp_takeaway = this.navParams.get('pvp_takeaway');
      this.ean = this.navParams.get('ean');
    } else {
      this.pvp = 0;
      this.pvp2 = 0;
      this.pvp3 = 0;
      this.pvp_supplement = 0;
      this.pvp_combo_extra = 0;
      this.pvp_takeaway = 0;
      this.ean = "";
    }

    this._currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es'); //Get user current symbol
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {
      //Si el show_alert es true i no estem fen un update al plat
      if (this.show_alert && !this.update_state) {
        let alert = this.alertCtrl.create({
          title: this.translate.instant('general-atencion'),
          message: this.translate.instant('general-salir-proceso-creacion'),
          subTitle: this.translate.instant('general-se-eliminara-elemento'),
          buttons: [
            {
              text: this.translate.instant('general-no'),
              role: 'cancel',
              handler: () => {
                this.globals.side_menu_active = 'stock';
                reject();
              },
            },
            {
              text: this.translate.instant('general-si'),
              handler: () => {
                this.productsServices.afs.collection('products').doc(this.product_uid).delete();
                resolve();
                this.navCtrl.setRoot(ArticlesListPage);
              },
            },
          ],
        });
        alert.present();
      } else {
        resolve();
      }
    });
  }

  update() {
    this.show_alert = false;
    //Si alguno de los precios es null o undefined, lo ponemos en 0
    if (this.pvp == undefined || this.pvp == null) {
      this.pvp = 0;
    }
    if (this.pvp2 == undefined || this.pvp2 == null) {
      this.pvp2 = 0;
    }
    if (this.pvp3 == undefined || this.pvp3 == null) {
      this.pvp3 = 0;
    }
    if (this.pvp_supplement == undefined || this.pvp_supplement == null) {
      this.pvp_supplement = 0;
    }
    if (this.pvp_combo_extra == undefined || this.pvp_combo_extra == null) {
      this.pvp_combo_extra = 0;
    }
    if (this.pvp_takeaway == undefined || this.pvp_takeaway == null) {
      this.pvp_takeaway = 0;
    }
    if (this.ean == undefined || this.ean == null) {
      this.ean = "";
    }
    if (!this.update_state) {
      this.pvp_takeaway = this.pvp;
    }

    this.productsServices.afs.collection('products').doc(this.product_uid).update({ //save new price of product
      'pvp': this.pvp,
      'pvp2': this.pvp2,
      'pvp3': this.pvp3,
      'pvp_supplement': this.pvp_supplement,
      'pvp_combo_extra': this.pvp_combo_extra,
      'pvp_takeaway': this.pvp_takeaway,
      'tax': this.product_tax,
      'ean': this.ean,
      'updated_at': new Date(),
      'updated_user': this.globals.user_name
    }).then(() => {
      this.analyticsServices.trackingExpArticles('update product', this.globals.tracking_exp['update_article'], this.product_uid);
      //dataset
      if (this.update_state) {
        this.globals.GAtrackView('Products', 'Products - Price - Update', this.globals.restaurant.email, 'Create/Update', 'Update price', 'Products', this.product_name);
        this.sendData();
        this.staticsServices.changeStateStaticWait(true);
        this.navCtrl.pop();
      } else {
        this.globals.GAtrackView('Products', 'Products - Price - Create', this.globals.restaurant.email, 'Create/Update', 'Update price', 'Products', this.product_name);
        this.navCtrl.push(ArticleViewPage, {
          article_type: 'product',
          article_uid: this.product_uid
        });
      }
    });
  }
  sendData() {
    this.globals.dataSet('pvp', this.pvp, '', this.pvp);//Send product pvp data
    this.globals.dataSet('pvp2', this.pvp2, '', this.pvp2);//Send product pvp2 data
    this.globals.dataSet('pvp3', this.pvp3, '', this.pvp3);//Send product pvp3 data
    this.globals.dataSet('pvp_supplement', this.pvp_supplement, '', this.pvp_supplement);//Send product pvp_supplement data
    this.globals.dataSet('pvp_combo_extra', this.pvp_combo_extra, '', this.pvp_combo_extra);//Send product pvp_combo_extra data
    this.globals.dataSet('pvp_takeaway', this.pvp_takeaway, '', this.pvp_takeaway);//Send product pvp_takeaway data
    this.globals.dataSet('product_tax', this.product_tax, '', this.product_tax);//Send product product_tax data
    this.globals.dataSet('product_ean', this.ean, '', this.ean);//Send product product_ean data
  }

  inputPrice() {
    if (this.globals.so_mobile) {
      let cssClasses = {
        'input-group': true,
        'w-110': true,
        'w-150': false
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'input-group': true,
        'w-150': true,
        'w-110': false
      }
      return cssClasses;
    }
  }

  profitFoodCost(price, _foodcost, _parts, _type) {
    var foodcost = (_foodcost / _parts) * _type
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(price, this.globals.RESTAURANT_TAX);
    return 100 - this.globals.regla3(price, foodcost);
  }

  async getSuggestedPrice() {
    if (this.globals.checkLimitsByLicense('dishes', 'ai')) {
      this.loaderAI = true;
      this.suggestedPrice = 0;
      var restaurant = "restaurante";
      var location = this.globals.restaurant.address;
      //prepare restaurante type and cuisine
      if (this.globals.restaurant.business) {
        restaurant = this.globals.getBusinessType(this.globals.restaurant.business);
      } if (this.globals.restaurant.business2) {
        restaurant = this.globals.getBusinessType(this.globals.restaurant.business2);
      }
      if (this.globals.restaurant.cuisine) {
        restaurant += " " + this.globals.getCuisineType(this.globals.restaurant.cuisine);
      } else {
        restaurant += " " + this.globals.getCuisineType(this.globals.restaurant.cuisine2);
      }
      //prepare location
      if (this.globals.restaurant.address_state) {
        location = this.globals.restaurant.address_state + ", " + this.globals.restaurant.address_province + ", " + this.globals.restaurant.address_country;
      }
      //prepare params for ai services
      var timeout = 30000;
      var response_format = { type: "json_object" };
      var prompt_es = "¿Qué precio medio tiene " + this.globals.nameLangSelectProduct(this.product) + " (" + this.globals.descriptionLangSelectArticle(this.product) + ") para un " + restaurant + " en " + location + "? Entrega únicamente el precio medio como valor numérico, sin unidades ni texto adicional, y en formato JSON. Utiliza el formato: { \"suggested_price\": [precio_sugerido] }."
      var messages = [
        {
          role: "system",
          content: "You are an expert AI assistant that provides accurate and concise information."
        },
        {
          role: "user",
          content: `Primero, traduce el siguiente texto del español al inglés, y luego responde al texto traducido en inglés, ayúdate buscando en internet e intenta que la información sea la más actual: '${prompt_es}'`
        }
      ];
      //call ai service function
      const response = await this.aiServices.openAIGenerateSuggestedPrice(response_format, messages, timeout);
      // convertimos el json text a json
      var AiResponse = response['choices'][0].message.content;
      var json_Response = JSON.parse(AiResponse);
      this.loaderAI = false;
      this.suggestedPrice = parseFloat(json_Response.suggested_price);
      //send slack
      var title = "AI SUGGESTED PRICE ARTICLE";
      var section = {
        "type": "section",
        "text": {
          "type": "mrkdwn",
          "text": ":hotel: " + this.globals.restaurant.company +
            "\n :email: " + this.globals.restaurant.email +
            "\n :knife_fork_plate: " + this.globals.nameLangSelectProduct(this.product) +
            "\n :keyboard: " + prompt_es +
            "\n :credit_card: " + AiResponse + "\n"
        }
      };
      this.globals.sendCustomerMctSlack(title, section);
    }
    else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/products/product-create/product-create-without-foodcost/product-create-wfoodcost-price/product-create-wfoodcost-price.ts